<wtls-google-map [controls]="controls"></wtls-google-map>
<div #matchControl class="control match-control">
    <wtls-match *ngIf="mapFullScreen"></wtls-match>
</div>